import React from "react";
import { ArrowRight, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyToInnovate() {
  return <section data-section-id="236894" id="start-your-evolution" className="bg-background text-foreground relative overflow-hidden py-48 px-6 flex items-center justify-center">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] opacity-20 blur-3xl rounded-lg"></div>
      </div>

      {}
      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center gap-8">
        <h2 className="text-5xl md:text-7xl font-bold font-default tracking-tighter text-foreground">
          Start Your Evolution
        </h2>
        
        <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl font-default font-light leading-relaxed">
          Empowering growth since 2017. Whether you're looking to master new skills or scale your operations through BPO, SKILLUP is your partner in progress.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mt-8 w-full sm:w-auto">
          <Button size="lg" className="h-14 px-8 text-base bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg transition-transform hover:scale-105 rounded-md" asChild>
            <Link to="/TrainingAcademyPage">
              Explore Training
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
          
          <Button size="lg" variant="outline" className="h-14 px-8 text-base border-secondary/50 hover:bg-secondary/10 text-foreground shadow-md transition-transform hover:scale-105 rounded-md" asChild>
            <Link to="/BpoServicesPage">
              <PhoneCall className="mr-2 size-5" />
              Outsource Today
            </Link>
          </Button>
        </div>

        <p className="text-sm text-muted-foreground/60 font-mono tracking-wide mt-4">
          No-obligation consultation
        </p>
      </div>
    </section>;
}